import { gql } from 'apollo-angular'

export const GET_RESELLERS = gql`
  query GetResellers {
    getAvailableResellers {
      organizationId
      name
    }
  }
`
